(function () {
    'use strict';
    $(document).ready(function () {

	    new Swiper("#partners-swiper", {
		    speed: 400,
		    spaceBetween: 0,
		    slidesPerView: 1,

		    pagination: {
			    el: "#partners-swiper .swiper-pagination",
			    clickable: true,
			    enabled: true
		    },

		    grid: {
				fill: "columns",
			    rows: 1,
		    },

		    breakpoints: {
			    // when window width is >= 640px
			    992: {
				    spaceBetween: 50,
				    slidesPerView: 4,

				    grid: {
					    fill: "columns",
					    rows: 3,
				    },
			    },
			    768: {
				    spaceBetween: 50,
				    slidesPerView: 3,

				    grid: {
					    fill: "columns",
					    rows: 3,
				    },
			    },
			    480: {
				    spaceBetween: 24,
				    slidesPerView: 3,

				    grid: {
					    fill: "columns",
					    rows: 2,
				    },
			    }
		    }
	    });

		$('.question-name').on("click", function(){
			$(this).toggleClass('active');
			$(this).siblings('.question-answer').slideToggle();
		})

    });
}(jQuery));
